import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useValidateAuthenticationQuery } from "store/services/authentication/authentication";
import { loadingStart, loadingEnd } from "store/features/loader/loaderSlice";

const MainAccountOnly = ({ children }) => {
  const dispatch = useDispatch();
  const validateAuthentication = useValidateAuthenticationQuery();

  useEffect(() => {
    if (validateAuthentication.isError) {
      // window.location.href = config.authUrl;
      return;
    }
    if (validateAuthentication.isLoading) {
      dispatch(loadingStart());
    }
    if (!validateAuthentication.isLoading){
      dispatch(loadingEnd());
    }
  }, [validateAuthentication.isError, validateAuthentication.data, validateAuthentication.isLoading, dispatch]);

  if (validateAuthentication.error) return null;

  return children;
};

export default MainAccountOnly;
